module.exports = __webpack_public_path__ + "img/AI_01.71213ee1.png";